import { AddressType } from '../../constants/address-type.js';
import { isBlankAddressPairForm } from '../address/is-blank-address-pair-form.js';
import { suggestVendorAddressName } from './rules.js';
/** True when nothing but the auto-suggested nicknames is filled in, so New Vendor creates no address. */
export function isBlankVendorAddressPairForm(values, vendorName) {
    const name = vendorName.trim();
    return isBlankAddressPairForm(values, {
        sameAsField: 'remitSameAsShipping',
        secondaryField: 'remit',
        shippingNickname: suggestVendorAddressName(name, AddressType.SHIPPING),
        secondaryNickname: suggestVendorAddressName(name, AddressType.REMIT_TO),
    });
}
//# sourceMappingURL=is-blank-vendor-address-pair-form.js.map